// extracted by mini-css-extract-plugin
export var button = "_8-0";
export var buttonContent = "_8-e";
export var buttonGroup = "_8-c";
export var dontRestrainIconWidth = "_8-a";
export var dropdownButton = "_8-b";
export var iconContainer = "_8-9";
export var lg = "_8-4";
export var md = "_8-3";
export var pending = "_8-f";
export var sm = "_8-2";
export var spinner = "_8-d";
export var squared = "_8-8";
export var wrapText = "_8-g";
export var xl = "_8-5";
export var xs = "_8-1";
export var xxl = "_8-6";
export var xxxl = "_8-7";